/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
// import SummaryCards from "../components/SummaryCards";
import FiltersBar from "../components/FiltersBar";
import BookingsTable from "../components/BookingsTable";
import Pagination from "../components/Pagination";
// import { calculateSummary, filterBookings } from "../utils/bookingUtils";
import BookingSlip from "../components/BookingSlip";
import { useNavigate } from "react-router-dom";
import QuickStatsCards from "../components/QuickStatsCards";
const API_URL = process.env.REACT_APP_API_URL;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [summary, setSummary] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [quickStats, setQuickStats] = useState(null);
const [halls, setHalls] = useState([]);
  const [search, setSearch] = useState("");
  const [hallFilter, setHallFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [dateRange, setDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);

  const [printBooking, setPrintBooking] = useState(null);
  const slipRef = useRef();

  /* ---------------- FETCH BOOKINGS ---------------- */

  const fetchBookings = async () => {
    try {
      const params = new URLSearchParams({
        search,
        hallId: hallFilter || "",
        status: statusFilter || "",
        fromDate: dateRange[0]?.startDate
          ? dateRange[0].startDate.toISOString().split("T")[0]
          : "",
        toDate: dateRange[0]?.endDate
          ? dateRange[0].endDate.toISOString().split("T")[0]
          : "",
        page: currentPage,
        limit: 20,
      });

      const res = await fetch(`${API_URL}/api/bookings?${params}`);
      const data = await res.json();

      console.log("API DATA 👉", data);

      setBookings(data.bookings);
      setSummary({
        totalBookings: data.summary?.TotalBookings || 0,
        todaysBookings: data.summary?.TodaysBookings || 0,
        totalRevenue: data.summary?.TotalRevenue || 0,
        monthRevenue: data.summary?.ThisMonthRevenue || 0,
      });
      setQuickStats(data.quickStats); // ✅ FIXED
      setTotalPages(Math.ceil(data.total / 20));
    } catch (err) {
      console.error("Fetch failed", err);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [search, hallFilter, statusFilter, dateRange, currentPage]);

  /* ---------------- EDIT BOOKING ---------------- */

   const handleEdit = async (id) => {
  try {
    const res = await fetch(`${API_URL}/api/bookings/${id}`);
    const data = await res.json();

    console.log("RAW EDIT DATA 👉", data);

    const normalized = {
      ...data,

      // ✅ FIX TAX
      taxBreakdown: (() => {
        try {
          return data.TaxBreakup
            ? JSON.parse(data.TaxBreakup)
            : [];
        } catch {
          return [];
        }
      })(),

      // ✅ FIX SERVICES (if not coming)
      services: data.services || [],

      // ✅ FIX IDs (important for dropdowns)
      eventTypeId: data.EventTypeId,
      hallId: data.HallId,
      packageId: data.PackageId,
    };

    console.log("NORMALIZED 👉", normalized);

    navigate("/", { state: { booking: normalized } });

  } catch (err) {
    console.error("Edit failed", err);
  }
};


  const fetchHalls = async () => {
  try {
    const res = await fetch(`${API_URL}/api/halls`);
    const data = await res.json();
    setHalls(data);
  } catch (err) {
    console.error("Failed to fetch halls", err);
  }
};

useEffect(() => {
  fetchHalls();
}, []);

  /* ---------------- CANCEL BOOKING ---------------- */

  const handleCancel = async (id) => {
    if (!window.confirm("Cancel this booking?")) return;

    await fetch(`${API_URL}/api/bookings/cancel/${id}`, { method: "PUT" });

    fetchBookings();
  };

  /* ---------------- NORMALIZE BOOKING FOR SLIP ---------------- */

  const normalizeBooking = (b) => ({
  fullName: b.FullName,
  mobile: b.Mobile,
  email: b.Email,
  city: b.City,

  bookingCode: b.BookingCode || `BK-${b.Id}`,   // ✅ ADD THIS

  eventType: b.EventType,
  eventDate: b.EventDate,

  startTime: b.StartTime,
  endTime: b.EndTime,

  hall: b.Hall,
  guests: b.Guests,

  total: b.SubTotal,
  advance: b.AdvanceAmount,

  catering: b.Catering,
  decoration: b.Decoration,
  stageSetup: b.StageSetup,
  dj: b.DJ,
  photography: b.Photography,
  parking: b.Parking,

  taxBreakdown: (() => {
    try {
      return JSON.parse(b.TaxBreakup || "[]");
    } catch {
      return [];
    }
  })(),
});

  /* ---------------- PRINT BOOKING ---------------- */

  const handleReprint = async (id) => {
    try {
      const res = await fetch(`${API_URL}/api/bookings/${id}`);
      const booking = await res.json();

      setPrintBooking(normalizeBooking(booking));

      setTimeout(() => {
        const content = slipRef.current.innerHTML;

        const printWindow = window.open("", "", "width=900,height=650");

        printWindow.document.write(`
          <html>
            <head>
              <title>Booking Slip</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 40px; }
              </style>
            </head>
            <body>${content}</body>
          </html>
        `);

        printWindow.document.close();

        printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
        };
      }, 200);
    } catch (err) {
      console.error("Print failed", err);
    }
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="max-w-7xl mx-auto p-8">
      {quickStats && <QuickStatsCards summary={quickStats} />}

      {/* {summary && <SummaryCards summary={summary} />} */}

      <FiltersBar
        search={search}
        setSearch={setSearch}
        hallFilter={hallFilter}
        setHallFilter={setHallFilter}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        dateRange={dateRange}
        setDateRange={setDateRange}
         halls={halls}
      />

      <BookingsTable
        bookings={bookings} // ✅ direct from API
        onEdit={handleEdit}
        onCancel={handleCancel}
        onReprint={handleReprint}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />

      {/* Hidden Printable Slip */}
      <div style={{ display: "none" }}>
        {printBooking && (
          <div ref={slipRef}>
            <BookingSlip data={printBooking} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
